module.exports = "/_next/static/images/plank-4f14c3811066b1b6dc402c276b5c6b24.webp";